<template>
    <v-tab-item :value="DELIVERY.value">
        <div class="page-section-wrap">
            <section class="page-section">
                <div>
                    <v-row>
                        <v-col cols="12" lg="3">
                            <h2 class="tit">픽업 및 배송</h2>
                        </v-col>
                        <v-col cols="12" lg="9">
                            <div>
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">직접 픽업</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>운송 주선 : 낙찰자 직접 작품 수령이 어려울 경우, 당사는 낙찰자의 책임과 비용 부담 하에, 미술품 운송 업체를 주선해드립니다.</span></li>
                                    <li><em>-</em><span>운송 주체 : 운송일정 및 장소, 비용 등의 세부적인 내용은 낙찰자가 운송업체와 직접 협의하시면 됩니다.</span></li>
                                    <li><em>-</em><span>택배 업체 : 작품 파손, 분실의 위험이 크므로 택배업체는 주선하지 않습니다.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">운송 주선</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>운송 주선 : 낙찰자 직접 작품 수령이 어려울 경우, 당사는 낙찰자의 책임과 비용 부담 하에, 미술품 운송 업체를 주선해드립니다.</span></li>
                                    <li><em>-</em><span>운송 주체 : 운송일정 및 장소, 비용 등의 세부적인 내용은 낙찰자가 운송업체와 직접 협의하시면 됩니다.</span></li>
                                    <li><em>-</em><span>택배 업체 : 작품 파손, 분실의 위험이 크므로 택배업체는 주선하지 않습니다.</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">보관 비용</h4>
                                </div>
                                <p class="page-text">낙찰 후 7일이 경과한 작품에 대해서는 건당 1일 1만원의 보관료(부가세 별도)가 발생합니다.</p>
                            </div>

                            <v-divider class="grey-cb my-30 my-md-36"></v-divider>

                            <div>
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Direct Pickup</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>Our principle : In principle, the successful bidder visits us and picks up the work directly.</span></li>
                                    <li><em>-</em><span>Pickup Deadline: Please pick up works that have been auctioned off within 7 days.</span></li>
                                    <li><em>-</em><span>Prior Reservation: Please make a reservation with us by the day before your visit, and then visit us. Pick-up may not be possible if you visit without prior reservation.</span></li>
                                    <li><em>-</em><span>Pick-up time: Our business hours are 10 am to 6 pm ※ Excluding lunch time (12 am to 1 pm) / Monday to Friday (excluding statutory holidays)</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Shipping Arrangement</h4>
                                </div>
                                <ul class="letter-list">
                                    <li><em>-</em><span>Shipping Arrangement : If it is difficult for the successful bidder to directly receive the artwork, we can arrange an art transport company under the responsibility and cost of the successful bidder.</span></li>
                                    <li><em>-</em><span>Shipping negotiation: The successful bidder can directly negotiate with the transport company for details such as transport schedule, location, and cost.</span></li>
                                    <li><em>-</em><span>Shipping agency : Because there is a high risk of damage or loss of the artwork, the small general transport company does not arrange for it</span></li>
                                </ul>
                            </div>
                            <div class="mt-18 mt-md-30">
                                <div class="mb-10">
                                    <h4 class="tit tit--xs">Storage Fee</h4>
                                </div>
                                <p class="page-text">For works that have passed 7 days after the auction ends, a storage fee of KRW 10,000 per day (excluding tax) will be charged.</p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </section>
        </div>
    </v-tab-item>
</template>

<script>
import { HOW_TO_BID_TABS } from "@/assets/variables";
const { DELIVERY } = HOW_TO_BID_TABS;
export default {
    data() {
        return {
            DELIVERY,
        };
    },
};
</script>

<style></style>
